// extracted by mini-css-extract-plugin
module.exports = {"image-wrapper":"xUtgk","iconAux":"V-qVO"};